<template>
  <Breadcrumbs
      title="Review Promotion"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Promotion Approval', path: '/promotion_approval' },
      { label: 'Review Promotion', path: `/review-promotion?promoId=${promoId}` }
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <!-- Pass promoId prop to form -->
      <reviewPromotionForm
        :promoId="promoId"
      />
    </div>
  </div>
</template>

<script>
import reviewPromotionForm from './review_promotion_form.vue'

export default {
  name: 'viewPromotion',
  components: {
    reviewPromotionForm,
  },
  computed: {
    promoId() {
      return this.$route.query.promoId; // read query param
    },
  }
}
</script>
